import {setCookie, getCookie, removeCookie} from './cookie';
import firebase from '../Services/firebase';

export default class Session {
  loguedIn;
  token;
  static session = null;

  constructor() {
    this.token = getCookie('@tkn');
    this.loguedIn = !!this.token;
  }

  static shared() {
    this.verifyToken();

    if (this.session === null) {
      this.session = new Session();
    }

    return this.session;
  }

  static verifyToken = () => {
    if (firebase.auth().currentUser) {
      firebase.auth().currentUser.getIdToken().then(token => {
        this.session.saveToken(token);
      });
    }
  }

  parseJwt() {
    var base64Url = this.token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  createSession(token) {
    this.loguedIn = true;
    this.saveToken(token);
  }

  removeSession() {
    this.loguedIn = false;
    this.removeToken();
  }

  saveToken(token) {
    this.token = token;
    setCookie('@tkn', token);
  }

  removeToken() {
    removeCookie('@tkn');
  }
};
